export enum OnlineSessionsViewType {
    Grid = 'grid',
    Table = 'table'
}
